import React, { useEffect, useRef, useState } from 'react';
import { Button } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { saveCourseVideoProgress } from '../../../../../../helper/api.helper';
import {
  getFileExtension,
  getOrgCode,
  sanitizeFileName
} from '../../../../../../helper/utils.helper';
import toast from 'react-hot-toast';

const CourseVideo = ({ setVisitedPages, section, courseActivityId }) => {
  const videoRef = useRef(null);
  const lastSavedRef = useRef(Date.now());
  const [videoDuration, setVideoDuration] = useState(0);
  const [currProgress, setCurrProgress] = useState(section?.currProgress || 0);
  const [maxProgress, setMaxProgress] = useState(section?.maxProgress || 0);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.currentTime = currProgress;
    }
  }, []);

  const handleLoadedMetadata = () => {
    const video = videoRef.current;
    if (video) {
      setVideoDuration(Math.round(video.duration));
    }
  };

  const handleTimeUpdate = () => {
    const video = videoRef.current;
    const currentTime = video.currentTime;
    const now = Date.now();

    if (currentTime > maxProgress + 1) {
      video.currentTime = maxProgress;
      return;
    }

    if (currentTime > maxProgress) {
      setMaxProgress(currentTime);
    }

    setCurrProgress(currentTime);

    if (now - lastSavedRef.current >= 60000) {
      lastSavedRef.current = now;
      const orgCode = getOrgCode();
      saveCourseVideoProgress(orgCode, courseActivityId, section.id, {
        currProgress: Math.round(currentTime),
        maxProgress: Math.round(Math.max(maxProgress, currentTime)),
        totalDuration: videoDuration
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.status === 'success') {
            console.log(res.message);
          } else {
            console.log(res.message);
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  };

  const handleVideoEnd = () => {
    setVisitedPages((prevState) => ({
      ...prevState,
      [section.id]: true
    }));
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(section.resourceUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const title = sanitizeFileName(section.name);
      const fileExtension = getFileExtension(section.resourceUrl);
      const filename = `${title}.${fileExtension}`;

      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading the file', error);
    }
  };

  return (
    <div className="video-wrapper">
      <h4>{section?.name}</h4>
      <div
        className="margin-top--lg"
        style={{
          maxHeight: '500px',
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center'
        }}
        onContextMenu={(e) => e.preventDefault()}>
        <video
          ref={videoRef}
          style={{ maxHeight: '400px', width: '100%' }}
          controls
          controlsList="nodownload"
          onTimeUpdate={handleTimeUpdate}
          onEnded={handleVideoEnd}
          onLoadedMetadata={handleLoadedMetadata}>
          <source src={section?.video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      {section.resourceUrl && (
        <Button
          style={{ marginTop: '20px', textTransform: 'none' }}
          endIcon={<FileDownloadOutlinedIcon color="primary" />}
          onClick={handleDownload}>
          {decodeURIComponent(section.resourceUrl).split('#')[0].split('?')[0].split('/').pop()}
        </Button>
      )}
      <style jsx>
        {`
          .video-wrapper {
            padding: 0px 40px 40px 40px;
          }
          @media only screen and (max-width: 600px) {
            .video-wrapper {
              padding: 0px 20px 20px 20px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default CourseVideo;
